<div class="auth-screen">
  @if (error()) {
    <!-- Error state: authentication failed -->
    <div class="app-page-card auth-card app-stack" role="alert">
      <div class="auth-brand">
        <div class="auth-icon-wrap error-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="auth-icon-svg">
            <circle cx="12" cy="12" r="10" fill="currentColor" opacity=".15"/>
            <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
        <h2>Sign-in Failed</h2>
      </div>
      <p class="app-muted">{{ error() }}</p>
      <div class="app-button-row">
        <calcite-button kind="neutral" appearance="solid" scale="m" (click)="navigateToLogin()">
          Back to Login
        </calcite-button>
      </div>
    </div>
  } @else {
    <!-- Loading / resolving state -->
    <div class="app-page-card auth-card app-stack" aria-live="polite" aria-busy="true">
      <div class="auth-brand">
        <div class="auth-icon-wrap" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="auth-icon-svg">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" fill="currentColor" opacity=".9"/>
            <polyline points="9 22 9 12 15 12 15 22" fill="#fff" opacity=".6"/>
          </svg>
        </div>
        <div class="app-stack">
          <h2>Signing you in…</h2>
          <p class="app-muted">Verifying your Microsoft Entra ID session.</p>
        </div>
      </div>
      <calcite-loader label="Signing you in" text="One moment…"></calcite-loader>
    </div>
  }
</div>
